import { Env } from '@/Env';
import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import { createWidget } from '@typeform/embed';
import '@typeform/embed/build/css/widget.css';
import { EmbedWidget } from '@typeform/embed/types/base';
import { WidgetOptions } from '@typeform/embed/types/factories/create-widget/widget-options';

class TypeFormEmbedService extends BaseService {
  createWidget(
    formId: string,
    htmlElement: HTMLElement,
    options: Partial<WidgetOptions>
  ): EmbedWidget {
    return createWidget(formId, {
      container: options.container ?? htmlElement,
      hideHeaders: options.hideHeaders ?? true,
      hideFooter: options.hideFooter ?? false,
      height: options.height ?? 1000,
      disableScroll: options.disableScroll ?? true,
      enableSandbox: Env.isRunningCypress() || !Env.isProduction(),
      ...options
    });
  }
}

export default new TypeFormEmbedService();
